// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TJ4W","label":"styles_label__3Vbk1"};